import { render, staticRenderFns } from "./ChatEventUserVideo.vue?vue&type=template&id=e7ec0a10&"
import script from "./ChatEventUserVideo.vue?vue&type=script&lang=js&"
export * from "./ChatEventUserVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports